module.exports = __webpack_public_path__ + "static/media/Upload.61ee547f.svg";